import { render } from "./AtomInfoCard.vue?vue&type=template&id=2f3ae12c&scoped=true&ts=true"
import script from "./AtomInfoCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomInfoCard.vue?vue&type=script&lang=ts&setup=true"

import "./AtomInfoCard.vue?vue&type=style&index=0&id=2f3ae12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3ae12c"],['__file',"src/components/atoms/AtomInfoCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f3ae12c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f3ae12c', __exports__)) {
    api.reload('2f3ae12c', __exports__)
  }
  
  module.hot.accept("./AtomInfoCard.vue?vue&type=template&id=2f3ae12c&scoped=true&ts=true", () => {
    api.rerender('2f3ae12c', render)
  })

}


export default __exports__